<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 19L0 19L1.74849e-07 18L24 18V19Z" fill="#D9D9D9"/>
<path d="M24 12L0 12L1.74849e-07 11L24 11V12Z" fill="#D9D9D9"/>
<path d="M24 5L0 5L1.74849e-07 4L24 4V5Z" fill="#D9D9D9"/>
</svg>
